import axios, { type AxiosInstance } from 'axios';
import { loggingService } from '../logging/loggingService';
import { API_ERROR_ACTIONS, LOG_STATUSES, getDefaultConfig } from '../logging/LoggingConstants';
import { getConfigValue } from './env';

function getBaseURL() {
    return getConfigValue('REACT_APP_API_URI') + getConfigValue('REACT_APP_GLOBAL_URI_PREFIX');
}

const inst: AxiosInstance = axios.create({
    baseURL: '',
    timeout: 120000,
});

inst.interceptors.response.use(
    (response) => response.data,
    (error) => {
        const originalRequest = error.config;
        const url = originalRequest?.url || '';
        const isLoggingEndpoint = url.includes(getDefaultConfig().LOG_ENDPOINT);

        if (error?.response?.data?.statusCode === 401) {
            localStorage.removeItem('user');
            localStorage.removeItem('access_token');
            window.location.href = '/';
        }

        if (!isLoggingEndpoint) {
            try {
                if (error.response) {
                    loggingService.log(API_ERROR_ACTIONS.API_ERROR, LOG_STATUSES.FAILURE, {
                        url,
                        method: originalRequest?.method?.toUpperCase() || 'UNKNOWN',
                        status: error.response.status,
                        statusText: error.response.statusText,
                        errorMessage: error.response?.data?.message || error.message,
                    });
                } else if (!error.response) {
                    loggingService.log(API_ERROR_ACTIONS.NETWORK_ERROR, LOG_STATUSES.FAILURE, {
                        url,
                        method: originalRequest?.method?.toUpperCase() || 'UNKNOWN',
                        message: error.message || 'Network error',
                    });
                }
            } catch (loggingError) {
                if (process.env.NODE_ENV === 'development') {
                    console.warn('Failed to log API error:', loggingError);
                }
            }
        }

        return Promise.reject(error);
    }
);

inst.interceptors.request.use(
    (req) => {
        req.baseURL = getBaseURL();
        const token = localStorage.getItem('access_token');
        if (token) {
            req.headers.set('Authorization', `Bearer ${token}`);
        }
        return req;
    },
    (error) => Promise.reject(error)
);

export default inst;
